import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import DigitizeImg from "../../images/location_new/fold5/img04.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";
import { Link } from 'gatsby'; // Import Gatsby's Link component

function Digitize(props) {
    return (
        <div className="digitize_sec p-100"  style={{backgroundColor: '#654297'}}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <h2>Unlock Digital Transformation With Leading Software Development Company in NYC</h2>
                        <p>TekRevol is a consumer-focused <Link to="/custom-software-development">custom software development company</Link> in New York City with years of experience helping modern businesses and enterprises with customer acquisition and digital transformation. Our expert software developers have developed exquisite technology solutions for businesses of all sizes and know how to help you succeed.</p>
                        <p>As a premier technology partner, we help our clients find the right avenues for profitability and leverage our technical expertise to capitalize on the opportunities. With a growth-centric approach, we work diligently to help our clients incorporate all the necessary functionalities that yield the best returns.</p>
                        <Link style={{backgroundColor: '#fff' , color:'#654297' , border:'1px solid #654297'}} 
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact" rel="noopener"
              >
               Book A Consultation Now!
              </Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
                        <LazyLoadImage
                            src={DigitizeImg}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Digitize;